import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import Button from "./Button";
import {StoreContext} from "../../stores/contexts";

class Buttons extends Component {
  static contextType = StoreContext;

  render() {
    const idField=this.context.configStore.config.data.id_field;
    return (
      <div data-id={this.props.row?this.props.row[idField]:null}>
        {this.props.buttons.map((item,index)=>{
          return <Button key={index} {...item} row={this.props.row} addClass={this.props.addClass} />
        })}
      </div>
    )
  }
}

// export default inject("configStore")(observer(Buttons));
export default observer(Buttons);